export default __webpack_public_path__ + "2ca4ea702825c3457bb65775b58785dd.js";